// extracted by mini-css-extract-plugin
export default {"content":"Employers_content__mRF4P","iconColumn":"Employers_iconColumn__b8tRl","nameColumn":"Employers_nameColumn__Z1RIc"};